import request from './request';
import deserialize from './deserialize';

export type Session = {
  id: string;
  token: string;
};

export function signIn(email: string, password: string) {
  return request<Session>({
    url: '/companion/v1/sign_in',
    method: 'POST',
    data: {
      data: {
        type: 'signin',
        attributes: {
          email,
          password,
        },
      },
    },
    transformResponse: deserialize,
  });
}
